import React, { useEffect } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Button, 
  Card, 
  CardContent,
  Paper
} from '@mui/material';
import { CheckCircle, Dashboard, Celebration } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PagamentoSucesso: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirecionar automaticamente após 5 segundos
    const timer = setTimeout(() => {
      navigate('/tw/dashboard');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
      <Card 
        elevation={6}
        sx={{ 
          borderRadius: 4,
          overflow: 'visible',
          position: 'relative'
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: -30,
            left: '50%',
            transform: 'translateX(-50%)',
            bgcolor: 'success.main',
            borderRadius: '50%',
            p: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 3
          }}
        >
          <CheckCircle sx={{ fontSize: 60, color: 'white' }} />
        </Box>

        <CardContent sx={{ pt: 6, pb: 4, textAlign: 'center' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <Celebration sx={{ fontSize: 40, color: 'primary.main', mr: 1 }} />
            <Celebration sx={{ fontSize: 40, color: 'secondary.main' }} />
          </Box>

          <Typography variant="h3" gutterBottom fontWeight="bold" color="primary">
            Pagamento Confirmado!
          </Typography>

          <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
            Bem-vindo ao ThinkWay! 🎉
          </Typography>

          <Paper 
            elevation={0} 
            sx={{ 
              bgcolor: 'success.50', 
              p: 3, 
              borderRadius: 2,
              border: '2px solid',
              borderColor: 'success.light',
              mb: 4
            }}
          >
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Parabéns!</strong> Seu pagamento foi processado com sucesso.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Agora você tem acesso completo a todas as funcionalidades premium:
            </Typography>
            <Box sx={{ mt: 2, textAlign: 'left', display: 'inline-block' }}>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                ✅ OKRs e Metas ilimitadas
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                ✅ Análise SWOT avançada
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                ✅ Planos de ação estratégicos
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                ✅ Relatórios personalizados
              </Typography>
              <Typography variant="body2">
                ✅ Suporte prioritário
              </Typography>
            </Box>
          </Paper>

          <Button
            variant="contained"
            size="large"
            startIcon={<Dashboard />}
            onClick={() => navigate('/tw/dashboard')}
            sx={{ 
              py: 2,
              px: 4,
              fontSize: '1.1rem',
              borderRadius: 3
            }}
          >
            Ir para o Dashboard
          </Button>

          <Typography variant="caption" color="text.secondary" sx={{ mt: 3, display: 'block' }}>
            Redirecionando automaticamente em alguns segundos...
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default PagamentoSucesso;
